export function sortByReferenceArray(arrToSort, referenceArr) {
    return [...arrToSort].sort((a, b) => {
        let indexA = referenceArr.indexOf(a.catId);
        let indexB = referenceArr.indexOf(b.catId);
        if(indexA === -1) indexA = Infinity;
        if(indexB === -1) indexB = Infinity;
        return indexA - indexB;
    });
}